import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "batch-loader__file" }
const _hoisted_2 = { class: "label-xs n-drag-and-drop__label" }
const _hoisted_3 = {
  class: "batch-loader__dnd-link label-m",
  for: "files"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_5 = { class: "label-2xs n-drag-and-drop__label" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_7 = {
  class: "batch-loader__dnd-link label-m",
  for: "folder"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "batch-loader__form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NAttachments = _resolveComponent("NAttachments")!
  const _component_NForm = _resolveComponent("NForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_NAttachments, {
        onAttach: _ctx.uploadDNDHandler,
        "disallow-attach": "",
        drag: "",
        "hide-amount": "",
        "hide-attachments": "",
        multiple: "",
        disabled: _ctx.attachDisabled
      }, {
        droparea: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('common.drag_and_drop_files')), 1),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
            class: "batch-loader__dnd-text"
          }, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('cards.select_files')), 1),
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('cards.or')), 1),
            _hoisted_6,
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('cards.select_folder')), 1),
            _createElementVNode("input", {
              type: "file",
              multiple: "",
              id: "files",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadHandler && _ctx.uploadHandler(...args))),
              class: "hide-element",
              disabled: _ctx.attachDisabled
            }, null, 40, _hoisted_8),
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("input", {
              type: "file",
              webkitdirectory: "",
              id: "folder",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadHandler && _ctx.uploadHandler(...args))),
              class: "hide-element",
              disabled: _ctx.attachDisabled
            }, null, 40, _hoisted_11)
          ])
        ]),
        _: 1
      }, 8, ["onAttach", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_NForm, {
        ref: "itemForm",
        layout: _ctx.schema,
        model: _ctx.batchModule.model,
        disabled: _ctx.attachDisabled
      }, null, 8, ["layout", "model", "disabled"])
    ])
  ], 64))
}